import { ActionControllerEventName } from "@g.frame/common.action_controller";
import { TEXTURE } from "@g.frame/common.loaders";
import { WindowComponent } from "@g.frame/components.window";
import { ParentEvent, ViewerModule } from "@g.frame/core";
import { Group, Mesh, MeshBasicMaterial, PlaneBufferGeometry, Vector2 } from "three";
export default class MuteButton extends ViewerModule {
    constructor(loader, actionController) {
        super();
        this.loader = loader;
        this.actionController = actionController;
        this.muted = false;
        this.toggleIcons = () => {
            this.muted = !this.muted;
            this.iconMeshMuted.visible = this.muted;
            this.iconMesh.visible = !this.muted;
            this.fire('music_toggle', new ParentEvent('music_toggle', { muted: this.muted }));
        };
        this.loader.addResources([
            {
                name: 'TEXTURE_mute',
                url: require('../../assets/volume_slash.png'),
                type: TEXTURE
            },
            {
                name: 'TEXTURE_volume',
                url: require('../../assets/volume.png'),
                type: TEXTURE
            },
        ]);
    }
    init() {
        this.createButtons();
        this.addEvent();
    }
    addEvent() {
        this.actionController.on(ActionControllerEventName.click, this.buttonGroup, this.toggleIcons);
    }
    createButtons() {
        this.buttonGroup = new Group;
        const size = new Vector2(0.045, 0.045);
        const border = new WindowComponent({
            size: size.clone().addScalar(size.y / 7),
            bordRadius: size.y / 3.5,
            background: 0x5D772E
        });
        border.uiObject.position.z = -0.0001;
        border.uiObject.position.y = -0.001;
        const background = new WindowComponent({
            size: size,
            bordRadius: size.y / 4,
            background: 0x9DC458
        });
        const iconSize = size.clone().multiplyScalar(0.7);
        const iconGeo = new PlaneBufferGeometry(iconSize.x, iconSize.y);
        this.iconMesh = new Mesh(iconGeo, new MeshBasicMaterial({ transparent: true, alphaTest: 0.5, map: this.loader.getResource('TEXTURE_volume') }));
        this.iconMesh.position.z = 0.0001;
        this.iconMeshMuted = new Mesh(iconGeo, new MeshBasicMaterial({ transparent: true, alphaTest: 0.5, map: this.loader.getResource('TEXTURE_mute') }));
        this.iconMeshMuted.position.z = 0.0001;
        this.iconMeshMuted.visible = false;
        this.buttonGroup.add(background.uiObject);
        this.buttonGroup.add(border.uiObject);
        this.buttonGroup.add(this.iconMesh);
        this.buttonGroup.add(this.iconMeshMuted);
        this.addObject(this.buttonGroup);
    }
}
